import DaumPostcode from "react-daum-postcode";
import CloseIcon from '../../../assets/icons/close.svg?react';

const StationAddressModal = ({
  onClose,
  onComplete
}) => {
  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-header">
          <h3>주소 검색</h3>
          <button className="close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content mt-10">
          <DaumPostcode onComplete={onComplete} />
        </div>
      </div>
    </div>
  )
}

export default StationAddressModal